/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';

export interface IPaginateProps {
  totalItems?: number;
  breakLabel?: string;
  nextLabel?: string;
  onPageChange?(event: any): void;
  pageRangeDisplayed?: number;
  totalPages?: number;
  totalCount?: number;
  forcePage?: number;
  previousLabel?: string;
}

export const Paginate = ({
  totalItems,
  totalCount,
  breakLabel,
  nextLabel,
  onPageChange,
  pageRangeDisplayed,
  totalPages,
  forcePage,
  previousLabel,
}: IPaginateProps) => {
  const [pages, setPages] = useState<number>(totalPages);
  const [count, setCount] = useState<number>(totalCount);

  useEffect(() => {
    if (totalPages > 0) {
      setPages(totalPages);
    }
  }, [totalPages]);

  useEffect(() => {
    if (totalCount) {
      setCount(totalCount);
    }
  }, [totalCount]);

  return (
    <Card.Footer className="px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
      <ReactPaginate
        breakLabel={breakLabel}
        nextLabel={nextLabel}
        forcePage={forcePage}
        onPageChange={onPageChange}
        pageRangeDisplayed={pageRangeDisplayed}
        pageCount={pages}
        previousLabel={previousLabel}
        breakClassName={'page-item'}
        breakLinkClassName={'page-link'}
        containerClassName={'pagination'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        previousClassName={'page-item'}
        previousLinkClassName={'page-link'}
        nextClassName={'page-item'}
        nextLinkClassName={'page-link'}
        activeClassName={'active'}
      />
      {totalItems && (
        <small
          className="fw-normal mt-4 mt-lg-0"
          style={{ justifyContent: 'flex-end' }}
        >
          Showing <b>{totalItems ?? 0}</b> out of <b>{count ?? 0}</b> entries
        </small>
      )}
    </Card.Footer>
  );
};

Paginate.defaultProps = {
  breakLabel: '...',
  nextLabel: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      className="icon icon-xs"
    >
      <path
        fillRule="evenodd"
        d="M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
        clipRule="evenodd"
      ></path>
      <path
        fillRule="evenodd"
        d="M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  ),
  pageRangeDisplayed: 5,
  previousLabel: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      className="icon icon-xs"
    >
      <path
        fillRule="evenodd"
        d="M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  ),
};
